import { render } from "./AssignmentList.vue?vue&type=template&id=5d4a6f71&scoped=true"
import script from "./AssignmentList.vue?vue&type=script&lang=js"
export * from "./AssignmentList.vue?vue&type=script&lang=js"

import "./AssignmentList.vue?vue&type=style&index=0&id=5d4a6f71&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/locales/ru/views/assignment-list.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAssignmentList.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/views/assignment-list.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FAssignmentList.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4a6f71"]])

export default __exports__